<!--
/*******************************************************************************
*@ 컴포넌트명   : ActionSheet.vue
*@ 컴포넌트설명 : actionSheet 공통컴포넌트
*@ 사용전문     :
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <section v-if="opened">
    <div class="action-sheet" :class="{ keypad: keyPad }">
      <div class="action-sheet-content" :class="[active]">
        <div v-if="actionHeader" class="action-sheet-header" :class="{ hasborder: useTopBorder, 'no-padding': noHeaderPadding }">
          <!-- 타이틀 -->
          <div class="action-sheet-title">
            <h4>{{ $t(title) }}</h4>
            <button class="btn-close" @click="close()"></button>
          </div>
          <!--// 타이틀 -->
          <!-- 서브 타이틀 -->
          <div class="description">
            <slot name="subtitle">
              {{ subtitle }}
              <br v-if="subtitle2" />
            </slot>
            <slot name="subtitle2">
              {{ subtitle2 }}
              <br v-if="subtitle3" />
            </slot>
            <slot name="subtitle3">{{ subtitle3 }}</slot>
          </div>
          <!--// 서브 타이틀 -->
        </div>
        <div v-if="actionBody" class="action-sheet-body" :class="[{ paddingbtm: !actionFooter }]">
          <slot name="content"></slot>
        </div>
        <footer v-if="actionFooter" class="action-sheet-footer" :class="[{ hasborder: useBottomBorder }]">
          <div class="btn-area--bottom">
            <slot name="footer">
              <button v-if="noNegativeButton" class="btn bottom negative" @click="cancelClick">{{ $t(cancel) }}</button>
              <button class="btn bottom positive" @click="confirmClick">{{ $t(confirm) }}</button>
            </slot>
          </div>
        </footer>
      </div>
    </div>
    <div v-if="noDimClose" class="action-sheet-dim"></div>
    <div v-else class="action-sheet-dim" @click="close()"></div>
  </section>
</template>
<style type="scss" scoped></style>
<script>
import { BaseComponent } from "@/components/base-component";
import ModalEvent from "@/components/modal-event";

export default {
  name: "action-sheet",
  extends: BaseComponent,
  mixins: [ModalEvent],
  props: {
    // header 사용여부
    actionHeader: { type: [Boolean], default: true },
    actionBody: { type: [Boolean], default: true },
    // footer (버튼) 사용여부
    actionFooter: { type: [Boolean], default: true },
    title: { type: String, default: undefined, required: false },
    subtitle: { type: String, default: undefined, required: false },
    subtitle2: { type: String, default: undefined, required: false },
    subtitle3: { type: String, default: undefined, required: false },
    width: { type: String, default: "100%", required: false },
    height: { type: String, default: "auto", required: false },
    cancel: { type: String, default: "MCOM-0000033", required: false },
    confirm: { type: String, default: "MCOM-0000034", required: false },
    opened: { type: Boolean, default: false },
    // 부정 버튼 사용 여부
    noNegativeButton: { type: Boolean, default: true },
    // 긍정 버튼 사용 여부
    noPositiveButton: { type: Boolean, default: false },
    // dim 영역 선택시 닫기 이벤트 방지
    noDimClose: { type: Boolean, default: false },
    useTopBorder: { type: Boolean, default: true, required: false },
    // fix bottom
    useBottomBorder: { type: Boolean, default: false, required: false },
    noHeaderPadding: { type: Boolean, default: false, required: false },
    // text keypad
    keyPad: { type: Boolean, default: false, required: false },
  },
  data() {
    return {
      active: "",
    };
  },
  computed: {
    hasCloseListener() {
      return this.$listeners && this.$listeners["close-button-clicked"];
    },
    uid() {
      return this._uid;
    },
  },
  watch: {
    opened: {
      handler(newData) {
        if (newData) {
          if (process.browser) {
            this.removeBodyScroll();
          }
          this.active = "slide-up";
        } else {
          if (process.browser) {
            this.addBodyScroll();
          }
          this.active = "slide-down";
        }
      },
    },
  },
  beforeDestroy() {
    if (process.browser) {
      this.addBodyScroll();
    }
  },
  methods: {
    close() {
      this.$emit("cancel");
      if (this.hasCloseListener) {
        this.$emit("close-button-clicked", () => this.done());
      } else {
        this.done();
      }
    },
    done() {
      this.$emit("update:opened", false);
    },
    confirmClick() {
      this.$emit("confirm");
      this.done();
    },
    cancelClick() {
      this.$emit("cancel");
      this.done();
    },
  },
};
</script>
